import { apiRequest } from "../../../services/api";

export const verifyEmail = async (token: string) => {
  const response = await apiRequest(
    "POST",
    `/auth/verify-email?token=${token}`
  );
  return response.data;
};
